import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LayerSelector from './LayerSelector';

/**
 * Class that houses the list of data layers in the Sidebar
 * Extends React.Component
*/
class LayersList extends Component {
  static propTypes = {
    activeLayers: PropTypes.arrayOf(PropTypes.string).isRequired,
    // eslint-disable-next-line
    dataLayers: PropTypes.object.isRequired,
    deselectMapLayer: PropTypes.func.isRequired,
    height: PropTypes.number,
    openLightbox: PropTypes.func.isRequired,
    selectMapLayer: PropTypes.func.isRequired,
    selectedTab: PropTypes.string.isRequired,
    zoomToLayerExtent: PropTypes.func.isRequired,
  };

  static defaultProps = {
    height: 'auto',
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.selectedTab !== this.props.selectedTab) {
      return true;
    }

    if (nextProps.activeLayers.length !== this.props.activeLayers.length) {
      return true;
    }

    if (nextProps.height !== this.props.height) {
      return true;
    }

    return false;
  }

  handleChange(value) {
    const { dataLayers, openLightbox, selectMapLayer, deselectMapLayer } = this.props;

    if (dataLayers[value].selected) {
      deselectMapLayer(value);

    } else {
      // hack: force open the lightbox for this one layer
      if (value.indexOf('deforestation_fronts') !== -1) {
        const name = dataLayers[value].layerlabel;
        const description = dataLayers[value].description;
        const shortdescription = dataLayers[value].shortdescription;
        const source = dataLayers[value].source;
        const sourceurl = dataLayers[value].sourceurl;
        const fullcitation = dataLayers[value].fullcitation;
        const payload = {
          name,
          description,
          shortdescription,
          source,
          sourceurl,
          fullcitation,
        };
        openLightbox('dataLayer', payload);
      }

      // and the usual selectMapLayer
      selectMapLayer(value);
    }
  }

  renderLayersList() {
    const { dataLayers, openLightbox, selectedTab, zoomToLayerExtent } = this.props;

    return Object.values(dataLayers)
      .filter(layer => layer.theme === selectedTab)
      .sort((a, b) => {
        if (a.listed_order < b.listed_order) {
          return -1;
        }
        if (a.listed_order > b.listed_order) {
          return 1;
        }
        return 0;
      })
      .map(layer => {
        const {
          datacode,
          layerlabel,
          selected,
          shortdescription,
          description,
          source,
          sourceurl,
          fullcitation,
        } = layer;

        return (
          <LayerSelector
            key={datacode}
            id={datacode}
            name={layerlabel}
            checked={selected}
            shortdescription={shortdescription}
            description={description}
            source={source}
            sourceurl={sourceurl}
            fullcitation={fullcitation}
            onChange={this.handleChange}
            openLightbox={openLightbox}
            onZoomBtnClick={zoomToLayerExtent}
          />
        );
      });
  }

  render() {
    // component height depends on whether or not Instructions UI is opened or closed
    const layersListStyle = {
      height: this.props.height || 'auto',
    };
    return (
      <div className="LayersList" style={layersListStyle}>
        {this.renderLayersList()}
      </div>
    );
  }
}

export default LayersList;



// WEBPACK FOOTER //
// ./src/components/LayersList.jsx